import {createReducer} from 'redux-act';
import {
  CLEAR_INVITE_A_BITE_DATA,
  GET_INVITE_A_BITE_INFO_SUCCESS,
  SET_LOADING
} from './action';

const initialState = () => ({
  data: null,
  loading: false
});

const inviteABiteReducer = createReducer(
  {
    [GET_INVITE_A_BITE_INFO_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload || null
    }),
    [SET_LOADING]: (state, payload) => ({
      ...state,
      loading: payload
    }),
    [CLEAR_INVITE_A_BITE_DATA]: () => initialState()
  },
  initialState()
);

export default inviteABiteReducer;
